import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useTable, usePagination, useSortBy } from 'react-table';
import caretDown from '../../images/icons/caretDown.svg';
import LocalPagination from './Pagination';

const DataTableComponent = ({ columnHeaders, tableData,
  isLoading, isError, error, localPagination }) => {
  const dispatch = useDispatch();

  const columns = useMemo(() => columnHeaders, []);
  const data = React.useMemo(() => tableData, [tableData]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 }
    },
    useSortBy,
    usePagination
  );

  if (isError) {
    return <>{error.message}</>;
  }

  return (
    <div className="">
      <div className="data-table-height-vendor overflow-auto po-table-modified">
        <table {...getTableProps()} className="table table-auto mx-auto">
          <thead className="" style={{ position: 'sticky', top: '0', zIndex: '1' }}>
            {headerGroups.map((headerGroup) => {
              return (
                <tr className="" {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => {
                    return (
                      <th className="th text-left py-3" {...column.getHeaderProps(column.getSortByToggleProps())}>
                        <span className="font-bold text-sm font-muli text-gray-500 capitalize px-1">{column.render('Header')}</span>
                        {column?.canSort && (
                          <span>
                            <img src={caretDown} alt="caretDown" className={`${column.isSorted ? 'transform rotate-180' : ''} inline-block`} />
                          </span>
                        )}
                      </th>
                    );
                  })}
                </tr>
              );
            })}
          </thead>
          <tbody {...getTableBodyProps()} className="">
            {isLoading ? (
              <h1>Loading ....</h1>
            ) : page.length > 0 ? (
              <>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell, index) => {
                        return (
                          <td
                            className="py-3"
                            {...cell.getCellProps()}
                            title={cell?.column?.id !== 'company' ? cell?.value : cell?.value?.map((item) => item?.props?.children)}
                          >
                            <span className={`text-sm font-muli  ${index > 0 ? 'text-gray-500 ' : 'text-gray-500'} px-2`}>{cell.render('Cell')}</span>
{' '}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </>
            ) : (
              <h1>No Data Available</h1>
            )}
          </tbody>
        </table>
      </div>

      {localPagination && (
        <LocalPagination
          {...{
            canPreviousPage,
            canNextPage,
            pageOptions,
            rowCount: [10, 20, 30, 40, 50],
            dispatch,
            gotoPage,
            nextPage,
            previousPage,
            setPageSize,
            pageIndex,
            pageSize
          }}
        />
      )}
    </div>
  );
};
export default DataTableComponent;
